import axios_ from "../utils/axios";

/**
 * @typedef {Object} Param
 * @property {string} cp_id 电商id
 * @property {string} name 名称/邮箱
 * @property {number} page 页码
 * @property {number} page_num 每页条数 默认10
 */

export default {
  /**
   * 主页列表
   * @typedef {Object} Request
   * @property {string} [page_name] 主页名称
   * @property {number} page 页码
   * @property {number} page_num 每页条数
   * @param {Request} param
   * @returns {Promise<DefaultResponseType>}
   */
  getAuthFbPages(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPage/lists`, param)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  /**
   * 获取电商平台列表
   * @typedef {Object} Param1
   * @property {string} [name] 名称
  //  * @property {1|2} [correlation] 是否关联1：全部 2：已关联
  //  * @property {string} [cs_id] 客服ID
   * @property {number} [page] 页码
   * @property {number} [page_num] 每页条数
   * @property {1|2} [type] 1 shopify 2 自建站
   * @param {Param1} param
   * @returns {Promise<DefaultResponseType>}
   */
  commercePlatforms(param) {
    return axios_("GET", `api/pandagpt/v1/commerce_platforms/lists`, param, false, false, true);
    // 下面 PHP 接口已废弃，改为 Python 接口，  上面 是 Python 接口
    // return axios_("GET", `api/pandagpt/v1/commercePlatforms/lists`, param);
  },
  /**
   * 获取 Python 优惠券模板列表，供营销工具的动态模板变量选择关联优惠券。
   * @param {{page?:number;page_num?:number}} params
   * @returns {Promise<DefaultResponseType>}
   */
  couponList(params) {
    return axios_("GET", "api/pandagpt/v1/coupon/list", params, false, false, true);
  },
  /**
   * 电商平台新增自建站授权
   * @param {{name:string;url:string}} param
   * @returns {Promise<DefaultResponseType>}
   */
  addStation(param) {
    return axios_(
      "POST",
      `api/pandagpt/v1/commercePlatforms/addStation`,
      param,
    );
  },
  /**
   * 删除独立站或者shopify
   * @param id
   * @returns {Promise<DefaultResponseType>}
   */
  deleteStation(id) {
    return axios_("POST", "api/pandagpt/v1/commercePlatforms/del", { id });
  },
  /**
   * 获取电商快递信息列表
   * @param {Param} param
   * @returns {Promise<DefaultResponseType>}
   */
  getShopExpressList(param) {
    return axios_("GET", "api/pandagpt/v1/shopExpress/lists", param);
  },
  /**
   * 上传独立站订单
   * @param {FormData} formData
   * @returns {Promise<DefaultResponseType>}
   */
  uploadExpress(formData) {
    return axios_(
      "POST",
      "api/pandagpt/v1/shopExpress/uploadExpress",
      formData,
    );
  },
  /**
   * 上传独立站商品
   * @param {FormData} formData
   * @returns {Promise<DefaultResponseType>}
   */
  uploadStoreProducts(formData) {
    return axios_(
      "POST",
      "api/pandagpt/v1/shopify/uploadStoreProducts",
      formData,
    );
  },
  /**
   * 机器人关联电商
   * @param {FormData} formData
   * @returns {Promise<DefaultResponseType>}
   */
  commercePlatformsCorrelation(formData) {
    return axios_(
      "POST",
      "/api/pandagpt/v1/commercePlatforms/correlation",
      formData,
    );
  },
  /**
   * 取消机器人关联电商
   * @param {FormData} formData
   * @returns {Promise<DefaultResponseType>}
   */
  commercePlatformsCorrelationdel(formData) {
    return axios_(
      "POST",
      "/api/pandagpt/v1/commercePlatforms/correlationdel",
      formData,
    );
  },

  /**
   * 获取shopify授权链接
   * @param {string} url shopify 商城地址
   * @return {Promise<DefaultResponseType>}
   */
  shopifyGetOauthUrl(url) {
    return axios_("GET", "api/shopify/getOauthUrl", { shop: url });
  },

  /**
   * 更新 shopify 订单信息
   * @param {string} shop shopify 商城地址
   * @returns { Promise<DefaultResponseType> }
   */
  shopifyUptShopify(shop) {
    return axios_("POST", "api/shopify/uptShopify", { shop });
  },

  /**
   * shopify 的授权回调
   * @param param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  shopifyCallback(param) {
    return axios_("POST", "api/shopify/callback", param);
  },
  /**
   * shopify产品列表接口
   * @param {Param} param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  shopifyProductList(param) {
    return axios_("GET", "api/pandagpt/v1/shopify/productLists", param);
  },

  // api/pandagpt/v1/shopify/orderLists
  /**
   * shopify订单列表接口
   * @param {Param} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  shopifyOrderList(params) {
    return axios_("GET", "api/pandagpt/v1/shopify/orderLists", params);
  },

  /**
   * 媒体管理 删除主页
   * @param {Param} params
   */
  pageDelete(params) {
    return axios_(
      "POST",
      "api/pandagpt/v1/platform/delete",
      params,
      false,
      false,
      true,
      false,
    );
  },

  /**
   * 媒体管理 解除主页授权
   * @param {Param} params
   */
  pageUnauth(params) {
    return axios_(
      "POST",
      "api/pandagpt/v1/platform/unauthorize",
      params,
      false,
      false,
      true,
      false,
    );
  },

  /**
   * 媒体管理 解除主页授权
   * @param {Param} params
   */
  pageBindInfo(params) {
    return axios_(
      "GET",
      "api/pandagpt/v1/platform/binding_info",
      params,
      false,
      false,
      true,
      false,
    );
  },

  /**
   * 获取shopline授权链接
   * @param {string} url shopline 商城地址
   * @return {Promise<DefaultResponseType>}
   */
  shoplineGetOauthUrl(url) {
    return axios_("GET", "api/shoplineWebsite/getOauthUrl", { shop: url });
  },
  /**
   * shopline 的授权回调
   * @param param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  shoplineCallback(param) {
    return axios_("POST", "api/shoplineWebsite/callback", param);
  },
  /**
   * 更新 shopline 订单信息
   * @param {string} shop shopline 商城地址
   * @returns { Promise<DefaultResponseType> }
   */
  shoplineUptShopline(shop) {
    return axios_("POST", "api/shoplineWebsite/uptShopline", { shop });
  },
  /**
   * shopline 订单列表接口
   * @param {Param} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  shoplineOrderList(params) {
    return axios_("GET", "api/shoplineWebsite/orderLists", params);
  },
  /**
   * shopline 产品列表接口
   * @param {Param} param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  shoplineProductList(param) {
    return axios_("GET", "api/shoplineWebsite/productLists", param);
  },

  /**
   * 获取 Shoplazza 授权链接。该接口由 Python 服务提供，需要使用 CN Python Host。
   * @param {{shop:string;store_id:string}} param 店铺系统域名与店铺 ID
   * @returns {Promise<DefaultResponseType>}
   */
  shoplazzaInstall(param) {
    return axios_("GET", "api/pandagpt/v1/shoplazza/install", param, false, false, true);
  },

  /**
   * 处理 Shoplazza 授权回调；Python 服务会校验授权码和签名并落库。
   * @author 陈宏发
   * @param {{code:string;shop:string;state:string;hmac:string}} param Shoplazza 回调参数
   * @returns {Promise<DefaultResponseType>}
   */
  shoplazzaCallback(param) {
    return axios_("GET", "api/pandagpt/v1/shoplazza/callback", param, false, false, true);
  },

  /**
   * 获取 Shoplazza 店铺订单；接口由 Python/CN 服务提供。
   * @author 陈宏发
   * @param {{store_id:number|string;page?:number;page_num?:number;search?:string}} params 订单筛选参数
   * @returns {Promise<DefaultResponseType>}
   */
  shoplazzaOrderList(params) {
    return axios_("GET", "api/pandagpt/v1/shoplazza/search_orders", params, false, false, true);
  },

  /**
   * 获取 Shoplazza 店铺商品；接口由 Python/CN 服务提供。
   * @author 陈宏发
   * @param {{store_id:number|string;page?:number;page_num?:number;updated_at_start?:string;updated_at_end?:string;published?:0|1|"";currency?:string;product_name?:string}} params 商品筛选参数
   * @returns {Promise<DefaultResponseType>}
   */
  shoplazzaProductList(params) {
    return axios_("GET", "api/pandagpt/v1/shoplazza/search_products", params, false, false, true);
  },
};
